import { useTranslation } from 'react-i18next'

import { useCookieConsent } from '@/hooks/useCookieConsent'
import { cn } from '@/lib/utils'

interface CookiePreferencesFooterLinkProps {
    className?: string
}

export const CookiePreferencesFooterLink = ({ className }: CookiePreferencesFooterLinkProps) => {
    const { t } = useTranslation()
    const { openPreferencesPanel } = useCookieConsent()

    return (
        <button
            type='button'
            onClick={openPreferencesPanel}
            className={cn('text-left text-sm text-[#E8DFD2] transition-opacity hover:opacity-85', className)}
        >
            {t('footer.cookiePreferences', 'Preferencias de cookies')}
        </button>
    )
}
